import React, { useState } from 'react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '1 — ¿Cómo recibo el MegaPack después de comprar?',
  answer: 'Inmediatamente después del pago recibís un email con el enlace de descarga. En menos de 5 minutos tenés los 6 tomos y los 6 bonos en tu celular o computadora. Acceso de por vida.'
}, {
  question: '2 — ¿Sirve para profes particulares o solo para clubes?',
  answer: 'Sirve para ambos. Tanto si enseñás en un club grande, un country o de forma independiente con 2-3 alumnos particulares. El sistema se adapta a cualquier formato de clase.'
}, {
  question: '3 — ¿Es editable? ¿Puedo modificarlo?',
  answer: 'Los tomos son PDF de alta resolución optimizados para celular y tablet. Podés imprimirlos, guardarlos y compartirlos con vos mismo entre dispositivos. No son editables para proteger el contenido original.'
}, {
  question: '4 — ¿Los 6 bonos están en las dos ofertas?',
  answer: 'Sí. Los 6 bonos estratégicos están incluidos en las dos opciones sin costo extra. La diferencia entre las dos ofertas es la inclusión de Academia Pro™ en la segunda.'
}, {
  question: '5 — ¿Sirve si soy profe nuevo con poca experiencia enseñando?',
  answer: 'Es ideal para profes nuevos. Todo está explicado paso a paso, con fichas de clase listas, consignas modelo y checklists de control. No necesitás años de experiencia para usarlo desde el primer día.'
}, {
  question: '6 — ¿Sirve para alumnos de todas las edades?',
  answer: 'Sí. El Tomo 1 cubre desde los 4 años (iniciación). El Tomo 2 trabaja con juniors de 10 a 14. El Tomo 3 está diseñado específicamente para adultos sociales. Los Tomos 4 y 5 para competidores avanzados. Hay contenido para cada edad.'
}, {
  question: '7 — ¿Qué pasa si tengo alumnos de distintos niveles al mismo tiempo?',
  answer: 'El Bono #1 "Clase Lista en 10 Min" tiene plantillas específicas para grupos mixtos. Te muestra cómo adaptar cualquier clase a grupos de distintos niveles con estaciones diferenciadas en menos de 10 minutos.'
}, {
  question: '8 — ¿Qué diferencia tiene el MegaPack con otros materiales de tenis?',
  answer: 'El MegaPack Tenis Listo es el único sistema en Argentina que combina planificación anual completa + técnica + táctica + físico + mental + gestión del negocio en un solo pack, adaptado al sistema de categorías argentino (AAT) y listo para usar sin adaptación previa.'
}, {
  question: '9 — ¿Por qué elegir el Combo Completo con Academia Pro?',
  answer: 'Porque el MegaPack resuelve el problema de la planificación. Academia Pro resuelve el problema del negocio. Si solo comprás el MegaPack tenés las mejores clases, pero podés seguir con los mismos problemas de cobro, retención y captación. El combo resuelve todo.'
}, {
  question: '10 — ¿Tiene garantía real?',
  answer: '100% real. 7 días, sin preguntas, sin formularios. Si no es lo que esperabas, te devolvemos el dinero completo. Más del 99% de los profes que lo compran lo usan y no lo devuelven.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-100">
      <div className="max-w-3xl mx-auto" data-id="element-101">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-10" data-id="element-102">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-3 mb-10" data-id="element-103">
          {faqs.map((faq, i) => <div key={i} className={`rounded-xl border transition-colors ${openIndex === i ? 'border-[#00B4D8] bg-[#000d1a]' : 'border-[#00B4D8]/20 bg-black'}`} data-id="element-104">
              <button className="w-full text-left px-5 py-4 flex items-center justify-between gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-105">
                <span className="text-white font-bold text-sm sm:text-base" data-id="element-106">
                  ❓ {faq.question}
                </span>
                <span className={`text-[#00B4D8] text-xl flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-107">
                  +
                </span>
              </button>
              {openIndex === i && <div className="px-5 pb-5" data-id="element-108">
                  <div className="h-px bg-[#00B4D8]/20 mb-4" data-id="element-109" />
                  {faq.answer.split('\n\n').map((para, j) => <p key={j} className="text-gray-200 text-sm leading-relaxed mb-3 last:mb-0" data-id="element-110">
                      {para}
                    </p>)}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}